@defer (when groupingUpdated()) {
  <app-theme-page-section>
    <main>
      <section class="details">
        <div class="form-group">
          <div for="title">Group title</div>
          <input id="title" name="title" maxlength="50" class="form-control" [(ngModel)]="groupingUpdated().title" />
        </div>

        <div class="form-group">
          <div for="notes">Notes</div>
          <textarea [(ngModel)]="groupingUpdated().notes"></textarea>
        </div>
      </section>
      <section class="users">
        <div>
          <div [style]="{ width: '100%', height: '340px' }">
            <div class="selected">
              <label>In Group</label>
              @if (groupingUpdated().users.length === 0) {
                <div><i class="red">No users</i></div>
              }
              <ul>
                @for (user of groupingUpdated().users; track user) {
                  <li (click)="removeUser(user)" class="can-click" tooltipPosition="left" title="- Remove from group">
                    {{ user.name }}
                  </li>
                }
              </ul>
            </div>

            <div class="available mt-1">
              <label>Available</label>
              <ul>
                @for (user of usersAvailable; track user) {
                  <li (click)="addUser(user)" class="can-click" tooltipPosition="left" title="+ Add to group">
                    {{ user.name }}
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>
      </section>
    </main>
    <footer>
      <div class="buttons mt-1">
        <div>
          <div>{{ message() }}</div>
        </div>
        <div>
          <app-button label="Cancel" icon="mdi mdi-close" (click)="cancel()"> </app-button>
          <app-button [label]="grouping().id ? 'Update' : 'Create'" icon="mdi mdi-content-save" (click)="submit()"> </app-button>
        </div>
      </div>
    </footer>
  </app-theme-page-section>
} @placeholder {
  <i class="mdi mdi-spin-x2 mdi-loading"></i>
}
